// Grand Opening promotion. TEMPORARY.
// To retire the promo entirely, set `enabled: false` below. Nothing else needs changing:
// the top banner, popup, homepage band, nav link and /grand-opening page all read this flag.
export const PROMO = {
  enabled: true,
  eyebrow: "Grand Opening",
  popupEyebrow: "Now Open",
  newPatientPath: "/new-patient-experience",
  title: "Grand Opening Offers",
  path: "/grand-opening",
  image:
    "https://static.prod-images.emergentagent.com/jobs/cf8d782d-f619-44e6-8b98-de375e49c8bc/images/f55bdd9aeadc16947462481e72e67dce299a677ac29e70b895f1407af6bc5fff.jpeg",
  imageAlt: "A patient relaxing in a calm, warm treatment room at Alae Dental",
  bannerText:
    "New patients receive a Philips Sonicare electric toothbrush, plus Invisalign from $4,500 and Zoom! whitening $399",
  bannerTextShort: "New patients receive a Philips Sonicare electric toothbrush",
  bannerCta: "See the offers",
  intro:
    "To welcome our new neighbours, we're opening our doors with limited time offers on the treatments patients ask us about most, plus a welcome gift for every new patient.",
  finePrint:
    "Limited time offer. Cannot be combined with other offers. Subject to clinical suitability.",
  newPatient: {
    id: "sonicare",
    eyebrow: "Limited Time Offer",
    title: "The Alae New Patient Experience",
    giftLine: "New patients receive a Philips Sonicare electric toothbrush.",
    giftLabel: "Our welcome gift to you",
    includes: [
      "Comprehensive examination",
      "Necessary digital X-rays",
      "iTero digital wellness scan",
      "Complete gum health assessment",
      "Professional hygiene care",
    ],
    finePrint:
      "Available for a limited time to new patients completing a New Patient Experience. While quantities last. Conditions apply.",
  },
  offers: [
    {
      id: "invisalign",
      name: "Invisalign\u00AE Comprehensive Treatment",
      price: "$4,500",
      description:
        "Includes comprehensive Invisalign\u00AE treatment, retainers and take-home whitening.",
      provider: "Treatment provided by a General Dentist",
      detail:
        "A full course of clear aligner treatment guided by Dr. Mirza, a General Dentist previously recognized as an Invisalign Gold Provider, from your first digital scan through to the retainers that protect your results.",
    },
    {
      id: "zoom-whitening",
      name: "Philips Zoom!\u00AE In-Office Whitening",
      price: "$399",
      description:
        "Professional in-office whitening for a noticeably brighter, refreshed smile in just one appointment.",
      provider: "Completed by a Registered Dental Hygienist",
      detail:
        "Professional strength whitening that safely lifts deep staining well beyond what over-the-counter kits can reach.",
    },
  ],
};
